import type { Component } from '@wix/thunderbolt-becky-types'
import { createCompNode, envRefs } from '@wix/thunderbolt-catharsis'
import { EMPTY_ARRAY } from '../../../utils/constants'
import { getMadeforFontFamillies } from '@wix/thunderbolt-becky-root'

export const madeforFontFamilies = {
	predicate: (component: Component) => component.type === 'Document', // only for masterPage
	compNode: createCompNode({
		getDependencies: () => ({ isWixSite: envRefs.isWixSite }),
		toViewItem: (__, { isWixSite }) => (isWixSite ? getMadeforFontFamillies() : EMPTY_ARRAY),
	}),
}
